import React from "react";
import {Layout, Breadcrumb, Row, Col, Button, Space, message, Typography} from 'antd';
import {ClearOutlined} from '@ant-design/icons';
import {getCookie, config} from "../helpers";
import Api from "../api";
import DailyPayments from "../components/charts/daily-payments";
import DailyVisitors from "../components/charts/daily-visitors";
import DailyRegistrations from "../components/charts/daily-registrations";
import LatestInvoices from "../components/charts/latest-invoices";
import ErrorLogChart from "../components/charts/error-log-chart";
import LatestComments from "../components/charts/latest-comments";
import LatestFeedPosts from "../components/charts/latest-feed-posts";

const {Content} = Layout;
const {Text} = Typography;

const Dashboard = () => {
    const apiUrl = getCookie('api_url') ? getCookie('api_url') : config('api.url');

    const clearCache = () => {
        Api.get('/admin/clear_cache').then(() => {
            message.success('Cache cleared!');
        }).catch(e => {
            message.error(`${e.message}`);
        });
    };

    return (
        <Content className="dashboard-page" style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
            </Breadcrumb>

            <div className="dashboard-page__header">
                <h1>Dashboard</h1>
                <Space wrap>
                    <Text className="dashboard-cache-label" title={apiUrl}>{apiUrl}</Text>
                    <Button onClick={clearCache} icon={<ClearOutlined/>}>Clear cache</Button>
                </Space>
            </div>

            <Row gutter={[16, 16]}>
                <Col xs={24} lg={12} xl={6}>
                    <DailyVisitors/>
                </Col>

                <Col xs={24} lg={12} xl={6}>
                    <DailyPayments/>
                </Col>

                <Col xs={24} lg={12} xl={6}>
                    <DailyRegistrations/>
                </Col>

                <Col xs={24} lg={12} xl={6}>
                    <ErrorLogChart/>
                </Col>

                <Col xs={24} lg={12} xl={8}>
                    <LatestInvoices/>
                </Col>

                <Col xs={24} lg={12} xl={8}>
                    <LatestComments/>
                </Col>

                <Col xs={24} lg={12} xl={8}>
                    <LatestFeedPosts/>
                </Col>
            </Row>
        </Content>
    );
};

export default Dashboard;
